import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { BTAlertTypeInsertRequest } from "./BTAlertTypeInsertRequest";
import { BTAlertTypeUpdateRequest } from "./BTAlertTypeUpdateRequest";
import { IntStringRequest } from "./IntStringRequest";

@Injectable()
export class DataService_BusTrackerAlertType {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	AlertTypeSelectAll() {
		var postResult$ = new Subject();
		var url = "BusTracker/AlertTypeSelectAll?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AlertTypeInsert(parms: BTAlertTypeInsertRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/AlertTypeInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AlertTypeUpdate(parms: BTAlertTypeUpdateRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/AlertTypeUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AlertTypeToggle(AlertTypeID, Active) {
		var postResult$ = new Subject();
		var url = "BusTracker/AlertTypeToggle?AlertTypeID=" + AlertTypeID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AlertTypeInUse(AlertTypeID) {
		var postResult$ = new Subject();
		var url = "BusTracker/AlertTypeInUse?AlertTypeID=" + AlertTypeID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AlertTypeDelete(AlertTypeID) {
		var postResult$ = new Subject();
		var url = "BusTracker/AlertTypeDelete?AlertTypeID=" + AlertTypeID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AlertTypeCDInUse(parms: IntStringRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/AlertTypeCDInUse";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AlertTypeDescInUse(parms: IntStringRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/AlertTypeDescInUse";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
